module.exports = __webpack_public_path__ + "static/media/suit_right_img.7162bc95.png";